'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDuration from "./java.time.-Duration.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
function $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__NANOS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MICROS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLIS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__SECONDS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MINUTES;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HOURS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DAYS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__WEEKS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MONTHS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__YEARS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__DECADES;
}
export { $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__CENTURIES;
}
export { $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA;
}
export { $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__ERAS;
}
export { $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit };
function $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit() {
  $m_Ljava_time_temporal_ChronoUnit$();
  return $t_Ljava_time_temporal_ChronoUnit$__FOREVER;
}
export { $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit as $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$() {
  $n_Ljava_time_temporal_ChronoUnit$ = this;
  $t_Ljava_time_temporal_ChronoUnit$__NANOS = new $c_Ljava_time_temporal_ChronoUnit$$anon$1();
  $t_Ljava_time_temporal_ChronoUnit$__MICROS = new $c_Ljava_time_temporal_ChronoUnit$$anon$2();
  $t_Ljava_time_temporal_ChronoUnit$__MILLIS = new $c_Ljava_time_temporal_ChronoUnit$$anon$3();
  $t_Ljava_time_temporal_ChronoUnit$__SECONDS = new $c_Ljava_time_temporal_ChronoUnit$$anon$4();
  $t_Ljava_time_temporal_ChronoUnit$__MINUTES = new $c_Ljava_time_temporal_ChronoUnit$$anon$5();
  $t_Ljava_time_temporal_ChronoUnit$__HOURS = new $c_Ljava_time_temporal_ChronoUnit$$anon$6();
  $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$7();
  $t_Ljava_time_temporal_ChronoUnit$__DAYS = new $c_Ljava_time_temporal_ChronoUnit$$anon$8();
  $t_Ljava_time_temporal_ChronoUnit$__WEEKS = new $c_Ljava_time_temporal_ChronoUnit$$anon$9();
  $t_Ljava_time_temporal_ChronoUnit$__MONTHS = new $c_Ljava_time_temporal_ChronoUnit$$anon$10();
  $t_Ljava_time_temporal_ChronoUnit$__YEARS = new $c_Ljava_time_temporal_ChronoUnit$$anon$11();
  $t_Ljava_time_temporal_ChronoUnit$__DECADES = new $c_Ljava_time_temporal_ChronoUnit$$anon$12();
  $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = new $c_Ljava_time_temporal_ChronoUnit$$anon$13();
  $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = new $c_Ljava_time_temporal_ChronoUnit$$anon$14();
  $t_Ljava_time_temporal_ChronoUnit$__ERAS = new $c_Ljava_time_temporal_ChronoUnit$$anon$15();
  $t_Ljava_time_temporal_ChronoUnit$__FOREVER = new $c_Ljava_time_temporal_ChronoUnit$$anon$16();
  $s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
  $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit();
}
export { $c_Ljava_time_temporal_ChronoUnit$ as $c_Ljava_time_temporal_ChronoUnit$ };
$p = $c_Ljava_time_temporal_ChronoUnit$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$() {
}
export { $h_Ljava_time_temporal_ChronoUnit$ as $h_Ljava_time_temporal_ChronoUnit$ };
$h_Ljava_time_temporal_ChronoUnit$.prototype = $p;
var $d_Ljava_time_temporal_ChronoUnit$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$, "java.time.temporal.ChronoUnit$", ({
  mi: 1,
  e: 1,
  aa: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$ as $d_Ljava_time_temporal_ChronoUnit$ };
var $n_Ljava_time_temporal_ChronoUnit$;
function $m_Ljava_time_temporal_ChronoUnit$() {
  if ((!$n_Ljava_time_temporal_ChronoUnit$)) {
    $n_Ljava_time_temporal_ChronoUnit$ = new $c_Ljava_time_temporal_ChronoUnit$();
  }
  return $n_Ljava_time_temporal_ChronoUnit$;
}
export { $m_Ljava_time_temporal_ChronoUnit$ as $m_Ljava_time_temporal_ChronoUnit$ };
function $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__($thiz, name, ordinal, duration, _$name, _$ordinal) {
  $thiz.dl = name;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__ as $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__ };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit() {
  this.q = null;
  this.M = 0;
  this.dl = null;
}
export { $c_Ljava_time_temporal_ChronoUnit as $c_Ljava_time_temporal_ChronoUnit };
$p = $c_Ljava_time_temporal_ChronoUnit.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit() {
}
export { $h_Ljava_time_temporal_ChronoUnit as $h_Ljava_time_temporal_ChronoUnit };
$h_Ljava_time_temporal_ChronoUnit.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.hk = (function() {
  return ((this.Ok($s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit()) >= 0) && (this !== $s_Ljava_time_temporal_ChronoUnit$__FOREVER__Ljava_time_temporal_ChronoUnit()));
});
$p.b = (function() {
  return this.dl;
});
function $isArrayOf_Ljava_time_temporal_ChronoUnit(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.a3)));
}
export { $isArrayOf_Ljava_time_temporal_ChronoUnit as $isArrayOf_Ljava_time_temporal_ChronoUnit };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$1() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Nanos", 0, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().Ce(1, 0), "NANOS", 0);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$1 as $c_Ljava_time_temporal_ChronoUnit$$anon$1 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$1;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$1() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$1 as $h_Ljava_time_temporal_ChronoUnit$$anon$1 };
$h_Ljava_time_temporal_ChronoUnit$$anon$1.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$1, "java.time.temporal.ChronoUnit$$anon$1", ({
  mj: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$1 as $d_Ljava_time_temporal_ChronoUnit$$anon$1 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$10() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Months", 9, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(2629746, 0, 0), "MONTHS", 9);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$10 as $c_Ljava_time_temporal_ChronoUnit$$anon$10 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$10;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$10() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$10 as $h_Ljava_time_temporal_ChronoUnit$$anon$10 };
$h_Ljava_time_temporal_ChronoUnit$$anon$10.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$10 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$10, "java.time.temporal.ChronoUnit$$anon$10", ({
  mk: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$10 as $d_Ljava_time_temporal_ChronoUnit$$anon$10 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$11() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Years", 10, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(31556952, 0, 0), "YEARS", 10);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$11 as $c_Ljava_time_temporal_ChronoUnit$$anon$11 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$11;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$11() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$11 as $h_Ljava_time_temporal_ChronoUnit$$anon$11 };
$h_Ljava_time_temporal_ChronoUnit$$anon$11.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$11 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$11, "java.time.temporal.ChronoUnit$$anon$11", ({
  ml: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$11 as $d_Ljava_time_temporal_ChronoUnit$$anon$11 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$12() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Decades", 11, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(315569520, 0, 0), "DECADES", 11);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$12 as $c_Ljava_time_temporal_ChronoUnit$$anon$12 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$12;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$12() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$12 as $h_Ljava_time_temporal_ChronoUnit$$anon$12 };
$h_Ljava_time_temporal_ChronoUnit$$anon$12.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$12 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$12, "java.time.temporal.ChronoUnit$$anon$12", ({
  mm: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$12 as $d_Ljava_time_temporal_ChronoUnit$$anon$12 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$13() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Centuries", 12, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV((-1139272096), 0, 0), "CENTURIES", 12);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$13 as $c_Ljava_time_temporal_ChronoUnit$$anon$13 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$13;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$13() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$13 as $h_Ljava_time_temporal_ChronoUnit$$anon$13 };
$h_Ljava_time_temporal_ChronoUnit$$anon$13.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$13 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$13, "java.time.temporal.ChronoUnit$$anon$13", ({
  mn: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$13 as $d_Ljava_time_temporal_ChronoUnit$$anon$13 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$14() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millenia", 13, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(1492180928, 7, 0), "MILLENNIA", 13);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$14 as $c_Ljava_time_temporal_ChronoUnit$$anon$14 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$14;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$14() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$14 as $h_Ljava_time_temporal_ChronoUnit$$anon$14 };
$h_Ljava_time_temporal_ChronoUnit$$anon$14.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$14 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$14, "java.time.temporal.ChronoUnit$$anon$14", ({
  mo: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$14 as $d_Ljava_time_temporal_ChronoUnit$$anon$14 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$15() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Eras", 14, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(1915187200, 7347425, 0), "ERAS", 14);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$15 as $c_Ljava_time_temporal_ChronoUnit$$anon$15 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$15;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$15() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$15 as $h_Ljava_time_temporal_ChronoUnit$$anon$15 };
$h_Ljava_time_temporal_ChronoUnit$$anon$15.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$15 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$15, "java.time.temporal.ChronoUnit$$anon$15", ({
  mp: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$15 as $d_Ljava_time_temporal_ChronoUnit$$anon$15 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$16() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Forever", 15, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().Ws((-1), 2147483647, 999999999, 0), "FOREVER", 15);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$16 as $c_Ljava_time_temporal_ChronoUnit$$anon$16 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$16;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$16() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$16 as $h_Ljava_time_temporal_ChronoUnit$$anon$16 };
$h_Ljava_time_temporal_ChronoUnit$$anon$16.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$16 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$16, "java.time.temporal.ChronoUnit$$anon$16", ({
  mq: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$16 as $d_Ljava_time_temporal_ChronoUnit$$anon$16 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$2() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Micros", 1, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().Ce(1000, 0), "MICROS", 1);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$2 as $c_Ljava_time_temporal_ChronoUnit$$anon$2 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$2;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$2() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$2 as $h_Ljava_time_temporal_ChronoUnit$$anon$2 };
$h_Ljava_time_temporal_ChronoUnit$$anon$2.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$2, "java.time.temporal.ChronoUnit$$anon$2", ({
  mr: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$2 as $d_Ljava_time_temporal_ChronoUnit$$anon$2 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$3() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Millis", 2, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().Ce(1000000, 0), "MILLIS", 2);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$3 as $c_Ljava_time_temporal_ChronoUnit$$anon$3 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$3;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$3() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$3 as $h_Ljava_time_temporal_ChronoUnit$$anon$3 };
$h_Ljava_time_temporal_ChronoUnit$$anon$3.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$3, "java.time.temporal.ChronoUnit$$anon$3", ({
  ms: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$3 as $d_Ljava_time_temporal_ChronoUnit$$anon$3 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$4() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Seconds", 3, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(1, 0, 0), "SECONDS", 3);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$4 as $c_Ljava_time_temporal_ChronoUnit$$anon$4 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$4() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$4 as $h_Ljava_time_temporal_ChronoUnit$$anon$4 };
$h_Ljava_time_temporal_ChronoUnit$$anon$4.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$4, "java.time.temporal.ChronoUnit$$anon$4", ({
  mt: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$4 as $d_Ljava_time_temporal_ChronoUnit$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$5() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Minutes", 4, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(60, 0, 0), "MINUTES", 4);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$5 as $c_Ljava_time_temporal_ChronoUnit$$anon$5 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$5() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$5 as $h_Ljava_time_temporal_ChronoUnit$$anon$5 };
$h_Ljava_time_temporal_ChronoUnit$$anon$5.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$5, "java.time.temporal.ChronoUnit$$anon$5", ({
  mu: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$5 as $d_Ljava_time_temporal_ChronoUnit$$anon$5 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$6() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Hours", 5, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(3600, 0, 0), "HOURS", 5);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$6 as $c_Ljava_time_temporal_ChronoUnit$$anon$6 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$6() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$6 as $h_Ljava_time_temporal_ChronoUnit$$anon$6 };
$h_Ljava_time_temporal_ChronoUnit$$anon$6.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$6, "java.time.temporal.ChronoUnit$$anon$6", ({
  mv: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$6 as $d_Ljava_time_temporal_ChronoUnit$$anon$6 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$7() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "HalfDays", 6, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(43200, 0, 0), "HALF_DAYS", 6);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$7 as $c_Ljava_time_temporal_ChronoUnit$$anon$7 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$7() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$7 as $h_Ljava_time_temporal_ChronoUnit$$anon$7 };
$h_Ljava_time_temporal_ChronoUnit$$anon$7.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$7 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$7, "java.time.temporal.ChronoUnit$$anon$7", ({
  mw: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$7 as $d_Ljava_time_temporal_ChronoUnit$$anon$7 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$8() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Days", 7, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(86400, 0, 0), "DAYS", 7);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$8 as $c_Ljava_time_temporal_ChronoUnit$$anon$8 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$8;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$8() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$8 as $h_Ljava_time_temporal_ChronoUnit$$anon$8 };
$h_Ljava_time_temporal_ChronoUnit$$anon$8.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$8 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$8, "java.time.temporal.ChronoUnit$$anon$8", ({
  mx: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$8 as $d_Ljava_time_temporal_ChronoUnit$$anon$8 };
/** @constructor */
function $c_Ljava_time_temporal_ChronoUnit$$anon$9() {
  this.q = null;
  this.M = 0;
  this.dl = null;
  $ct_Ljava_time_temporal_ChronoUnit__T__I__Ljava_time_Duration__T__I__(this, "Weeks", 8, $j_java$002etime$002e$002dDuration.$m_Ljava_time_Duration$().eV(604800, 0, 0), "WEEKS", 8);
}
export { $c_Ljava_time_temporal_ChronoUnit$$anon$9 as $c_Ljava_time_temporal_ChronoUnit$$anon$9 };
$p = $c_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = new $h_Ljava_time_temporal_ChronoUnit();
$p.constructor = $c_Ljava_time_temporal_ChronoUnit$$anon$9;
/** @constructor */
function $h_Ljava_time_temporal_ChronoUnit$$anon$9() {
}
export { $h_Ljava_time_temporal_ChronoUnit$$anon$9 as $h_Ljava_time_temporal_ChronoUnit$$anon$9 };
$h_Ljava_time_temporal_ChronoUnit$$anon$9.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_temporal_ChronoUnit$$anon$9 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ChronoUnit$$anon$9, "java.time.temporal.ChronoUnit$$anon$9", ({
  my: 1,
  a3: 1,
  n: 1,
  j: 1,
  a: 1,
  a4: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_temporal_ChronoUnit$$anon$9 as $d_Ljava_time_temporal_ChronoUnit$$anon$9 };
var $t_Ljava_time_temporal_ChronoUnit$__NANOS = null;
function $u_Ljava_time_temporal_ChronoUnit$__NANOS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__NANOS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__NANOS as $t_Ljava_time_temporal_ChronoUnit$__NANOS, $u_Ljava_time_temporal_ChronoUnit$__NANOS as $u_Ljava_time_temporal_ChronoUnit$__NANOS };
var $t_Ljava_time_temporal_ChronoUnit$__MICROS = null;
function $u_Ljava_time_temporal_ChronoUnit$__MICROS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MICROS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MICROS as $t_Ljava_time_temporal_ChronoUnit$__MICROS, $u_Ljava_time_temporal_ChronoUnit$__MICROS as $u_Ljava_time_temporal_ChronoUnit$__MICROS };
var $t_Ljava_time_temporal_ChronoUnit$__MILLIS = null;
function $u_Ljava_time_temporal_ChronoUnit$__MILLIS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MILLIS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MILLIS as $t_Ljava_time_temporal_ChronoUnit$__MILLIS, $u_Ljava_time_temporal_ChronoUnit$__MILLIS as $u_Ljava_time_temporal_ChronoUnit$__MILLIS };
var $t_Ljava_time_temporal_ChronoUnit$__SECONDS = null;
function $u_Ljava_time_temporal_ChronoUnit$__SECONDS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__SECONDS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__SECONDS as $t_Ljava_time_temporal_ChronoUnit$__SECONDS, $u_Ljava_time_temporal_ChronoUnit$__SECONDS as $u_Ljava_time_temporal_ChronoUnit$__SECONDS };
var $t_Ljava_time_temporal_ChronoUnit$__MINUTES = null;
function $u_Ljava_time_temporal_ChronoUnit$__MINUTES(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MINUTES = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MINUTES as $t_Ljava_time_temporal_ChronoUnit$__MINUTES, $u_Ljava_time_temporal_ChronoUnit$__MINUTES as $u_Ljava_time_temporal_ChronoUnit$__MINUTES };
var $t_Ljava_time_temporal_ChronoUnit$__HOURS = null;
function $u_Ljava_time_temporal_ChronoUnit$__HOURS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__HOURS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__HOURS as $t_Ljava_time_temporal_ChronoUnit$__HOURS, $u_Ljava_time_temporal_ChronoUnit$__HOURS as $u_Ljava_time_temporal_ChronoUnit$__HOURS };
var $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = null;
function $u_Ljava_time_temporal_ChronoUnit$__HALF_DAYS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS as $t_Ljava_time_temporal_ChronoUnit$__HALF_DAYS, $u_Ljava_time_temporal_ChronoUnit$__HALF_DAYS as $u_Ljava_time_temporal_ChronoUnit$__HALF_DAYS };
var $t_Ljava_time_temporal_ChronoUnit$__DAYS = null;
function $u_Ljava_time_temporal_ChronoUnit$__DAYS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__DAYS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__DAYS as $t_Ljava_time_temporal_ChronoUnit$__DAYS, $u_Ljava_time_temporal_ChronoUnit$__DAYS as $u_Ljava_time_temporal_ChronoUnit$__DAYS };
var $t_Ljava_time_temporal_ChronoUnit$__WEEKS = null;
function $u_Ljava_time_temporal_ChronoUnit$__WEEKS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__WEEKS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__WEEKS as $t_Ljava_time_temporal_ChronoUnit$__WEEKS, $u_Ljava_time_temporal_ChronoUnit$__WEEKS as $u_Ljava_time_temporal_ChronoUnit$__WEEKS };
var $t_Ljava_time_temporal_ChronoUnit$__MONTHS = null;
function $u_Ljava_time_temporal_ChronoUnit$__MONTHS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MONTHS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MONTHS as $t_Ljava_time_temporal_ChronoUnit$__MONTHS, $u_Ljava_time_temporal_ChronoUnit$__MONTHS as $u_Ljava_time_temporal_ChronoUnit$__MONTHS };
var $t_Ljava_time_temporal_ChronoUnit$__YEARS = null;
function $u_Ljava_time_temporal_ChronoUnit$__YEARS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__YEARS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__YEARS as $t_Ljava_time_temporal_ChronoUnit$__YEARS, $u_Ljava_time_temporal_ChronoUnit$__YEARS as $u_Ljava_time_temporal_ChronoUnit$__YEARS };
var $t_Ljava_time_temporal_ChronoUnit$__DECADES = null;
function $u_Ljava_time_temporal_ChronoUnit$__DECADES(x) {
  $t_Ljava_time_temporal_ChronoUnit$__DECADES = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__DECADES as $t_Ljava_time_temporal_ChronoUnit$__DECADES, $u_Ljava_time_temporal_ChronoUnit$__DECADES as $u_Ljava_time_temporal_ChronoUnit$__DECADES };
var $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = null;
function $u_Ljava_time_temporal_ChronoUnit$__CENTURIES(x) {
  $t_Ljava_time_temporal_ChronoUnit$__CENTURIES = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__CENTURIES as $t_Ljava_time_temporal_ChronoUnit$__CENTURIES, $u_Ljava_time_temporal_ChronoUnit$__CENTURIES as $u_Ljava_time_temporal_ChronoUnit$__CENTURIES };
var $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = null;
function $u_Ljava_time_temporal_ChronoUnit$__MILLENNIA(x) {
  $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA as $t_Ljava_time_temporal_ChronoUnit$__MILLENNIA, $u_Ljava_time_temporal_ChronoUnit$__MILLENNIA as $u_Ljava_time_temporal_ChronoUnit$__MILLENNIA };
var $t_Ljava_time_temporal_ChronoUnit$__ERAS = null;
function $u_Ljava_time_temporal_ChronoUnit$__ERAS(x) {
  $t_Ljava_time_temporal_ChronoUnit$__ERAS = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__ERAS as $t_Ljava_time_temporal_ChronoUnit$__ERAS, $u_Ljava_time_temporal_ChronoUnit$__ERAS as $u_Ljava_time_temporal_ChronoUnit$__ERAS };
var $t_Ljava_time_temporal_ChronoUnit$__FOREVER = null;
function $u_Ljava_time_temporal_ChronoUnit$__FOREVER(x) {
  $t_Ljava_time_temporal_ChronoUnit$__FOREVER = x;
}
export { $t_Ljava_time_temporal_ChronoUnit$__FOREVER as $t_Ljava_time_temporal_ChronoUnit$__FOREVER, $u_Ljava_time_temporal_ChronoUnit$__FOREVER as $u_Ljava_time_temporal_ChronoUnit$__FOREVER };
